import { useCallback, useMemo } from 'react';
import { useQuery } from 'react-query';
import { getPermissions } from '../../services/PermissionsService';

const usePermissions = (
  serviceBaseUrl: string,
  ocpApimKey: string,
  permissionCategory: 'Functional' | 'LocalData' = 'Functional'
) => {
  const { data, isLoading } = useQuery(
    `permissions_${permissionCategory}`,
    () => getPermissions(serviceBaseUrl, ocpApimKey, permissionCategory),
    {
      staleTime: Infinity,
      keepPreviousData: true,
    }
  );

  const grantedPermissionKeys = useMemo(
    () => data?.map((d) => d.permission) || [],
    [data]
  );

  const isGranted = useCallback(
    (permissionKey: string) => grantedPermissionKeys.includes(permissionKey),
    [grantedPermissionKeys]
  );

  return {
    isGranted,
    isLoading,
    grantedPermissionKeys,
  };
};

export { usePermissions };
